export default __webpack_public_path__ + "static/media/main_screen_jms.2866fef5.png";